import { Constant } from 'src/shared/constants';
import * as Yup from 'yup';

export interface IGeocoderResponse {
	latitude?: Number;
	longitude?: Number;
	addressLine1?: string;
	addressLine2?: string;
	pincode?: string;
	city?: string;
	state?: string;
	stateCode?: string;
	country?: string;
	countryCode?: string;
}

export interface IGeocoderRequest {
	addressLine1?: string;
	addressLine2?: string;
	pincode?: string;
	city?: string;
	state?: string;
	stateCode?: string;
	country?: string;
	countryCode?: string;
}

export interface IDivisionData {
	[key: string]: string
}

export interface ICountry {
	name: string;
	divisions: IDivisionData;
}

export interface ICountryState {
	[key: string]: ICountry;
}

export const GetGeocoderFormInitialValues = () => {
	return {
		addressLine1: '',
		addressLine2: '',
		pincode: '',
		city: '',
		state: '',
		stateCode: '',
		country: '',
		countryCode: Constant.defaultCountryCode,
	};
};

export const GetGeocoderFormValidationSchema = (t: any) => {
	return Yup.object().shape({
		pincode: Yup.string()
			.transform((value, originalValue) => {
				// Slice the original value to the desired length
				const slicedValue = originalValue.toString().slice(0, 6);
				// Return the sliced value
				return slicedValue;
			})
			.nullable()
			.length(6, t('message-pincode-length')), // Set max length to 6, // Assuming pincode can be null or undefined

		city: Yup.string().when('pincode', {
			is: pincode => !pincode || pincode.length !== 6, // If pincode is not provided
			then: Yup.string().required(t('message-city-required')),
			otherwise: Yup.string().notRequired(),
		}),

		stateCode: Yup.string().when('pincode', {
			is: pincode => !pincode || pincode.length !== 6, // If pincode is not provided
			then: Yup.string().required(t('message-state-required')),
			otherwise: Yup.string().notRequired(),
		}),

		countryCode: Yup.string().when('pincode', {
			is: pincode => !pincode || pincode.length !== 6, // If pincode is not provided
			then: Yup.string().required(t('message-country-required')),
			otherwise: Yup.string().notRequired(),
		}),
	});
};
